export function snakeToCamel(input: string): string {
  return input.split('_').reduce((acc, curr, i) => {
    if (!curr) {
      return `${acc}_`
    }

    curr = i !== 0 ? curr[0].toUpperCase() + curr.slice(1) : curr

    return `${acc}${curr}`
  }, '')
}
